import React from 'react';
import * as S from './style';
import { Btn } from 'components';

export interface Props {
    categorys: Array<{ name: string; isActive: boolean; onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void }>;
}

function CategoryTab({ categorys }: Props): React.ReactElement {
    return (
        <S.TabContainer>
            {categorys.map((item, index) => (
                <Btn key={index} fontStyle={'body2'} color={'gray_opacity_800'} backGroundColor={item.isActive ? 'gray_opacity_50' : 'transparent'} radius={6} height={28} onClick={item.onClick}>
                    {item.name}
                </Btn>
            ))}
        </S.TabContainer>
    );
}

export default CategoryTab;
